import forEach from 'lodash/forEach';

import AgentActivityGateway from '@ad-scripts/adapters/gateways/agent_activity_gateway';
import AgentSkillsGateway from '@ad-scripts/adapters/gateways/agent_skills_gateway';
import AgentUserUploadsGateway from '@ad-scripts/adapters/gateways/agent_user_uploads_gateway';
import AnswerSearchGateway from '@ad-scripts/adapters/gateways/snippet_search_result_http_gateway';
import AuthenticationGateway from './gateway/authentication_gateway';
import AutolinkingLookupDebuggingGateway from './gateway/autolinking_lookup_debugger_gateway';
import BasicLookupDebuggingGateway from './gateway/basic_lookup_debugger_gateway';
import ComplianceEventsHttpGateway from '@ad-scripts/adapters/gateways/compliance_events_http_gateway';
import DetailedLookupDebuggingGateway from './gateway/detailed_lookup_debugger_gateway';
import EmailDomainHttpGateway from '@ad-scripts/adapters/gateways/email_domain_gateway';
import EndpointsGateway from '@ad-scripts/adapters/gateways/endpoints_gateway';
import { gatewayEndpoints } from './registerGateway';
import generateId from 'src/lib/generateId';
import IvrsGateway from './gateway/ivrs_gateway';
import RecipientCollectionGateway from './gateway/recipient_collection_gateway';
import RecordingsGateway from './gateway/recordings_gateway';
import RulesGateway from '@ad-scripts/adapters/gateways/rules_gateway';
import SearchDropdownGateway from './gateway/search_dropdown_gateway';
import SkillGateway from '@ad-scripts/adapters/gateways/skill_gateway';
import StandardGateway from '@ad-scripts/adapters/gateways/lib/standard_gateway';
import StandardHttpConfigGateway from '@ad-scripts/adapters/gateways/standard_http_config';
import TeamsHttpGateway from '@ad-scripts/adapters/gateways/team_http_gateway';
import TemporaryAuthTokensGateway from './gateway/temporary_token_gateway';
import ThreadsGateway from 'src/configuration/gateway/threads_gateway';
import UserHttpGateway from '@ad-scripts/adapters/gateways/user_http_gateway';
import SidekickExternalActionsHttpGateway from '@ad-scripts/adapters/gateways/sidekick_external_actions_http_gateway';
import SidekickFlowsHttpGateway from '@ad-scripts/adapters/gateways/sidekick_flows_http_gateway';
import SidekickHttpGateway from '@ad-scripts/adapters/gateways/sidekick_http_gateway';

const configureGateways = (backend: any) => {
  const requestorId = generateId();
  const gateways = {};
  forEach(gatewayEndpoints, ([name, endpoint]) => {
    gateways[name] = new StandardGateway(backend, endpoint);
  });

  // custom gateways
  gateways['agentActivity'] = new AgentActivityGateway(backend.mqttClient, requestorId);
  gateways['agentSkills'] = new AgentSkillsGateway(backend);
  gateways['agentUserUploads'] = new AgentUserUploadsGateway(backend);
  gateways['answerSearch'] = new AnswerSearchGateway(backend);
  gateways['answerTitles'] = new StandardGateway(backend, 'v1/orgs/:orgId/help-center/:helpCenterId/answer-titles');
  gateways['auth'] = new AuthenticationGateway(backend);
  gateways['autolinkingLookupDebugging'] = new AutolinkingLookupDebuggingGateway(backend);
  gateways['availableNumbers'] = new StandardHttpConfigGateway(backend, 'v1/orgs/:orgId/available-numbers');
  gateways['basicLookupDebugging'] = new BasicLookupDebuggingGateway(backend);
  gateways['complianceEvents'] = new ComplianceEventsHttpGateway(backend);
  gateways['conversationWorkflow'] = new StandardGateway(backend, 'v1/orgs/:orgId/configuration/conversation-workflow');
  gateways['detailedLookupDebugging'] = new DetailedLookupDebuggingGateway(backend);
  gateways['emailDomains'] = new EmailDomainHttpGateway(backend);
  gateways['endpoints'] = new EndpointsGateway(backend);
  gateways['ivrs'] = new IvrsGateway(backend);
  gateways['publicAnswers'] = new StandardGateway(backend, 'v1/orgs/:orgId/answers');
  gateways['recipientCollections'] = new RecipientCollectionGateway(backend);
  gateways['recordings'] = new RecordingsGateway(backend);
  gateways['reportBuilderConfig'] = new StandardGateway(backend, 'v1/orgs/:orgId/configuration/report-builder');
  gateways['roles'] = new StandardGateway(backend, 'v1/orgs/:orgId/roles');
  gateways['rules'] = new RulesGateway(backend);
  gateways['searchDropdown'] = new SearchDropdownGateway(backend);
  gateways['sidekickAdmins'] = new SidekickHttpGateway(
    backend,
    'v1/orgs/:orgId/sidekick-dashboard/customers/:customerId/admins/:id'
  );
  gateways['sidekickExternalActions'] = new SidekickExternalActionsHttpGateway(backend);
  gateways['sidekickFastThreads'] = new SidekickHttpGateway(
    backend,
    'v1/orgs/:orgId/sidekick-dashboard/customers/:customerId/flows/fast'
  );
  gateways['sidekickIntegrationsGateway'] = new StandardGateway(
    backend,
    'v1/orgs/:orgId/sidekick-dashboard/customers/:customerId/flows-next/integrations'
  );
  gateways['sidekickRevisions'] = new SidekickHttpGateway(
    backend,
    'v1/orgs/:orgId/sidekick-dashboard/customers/:customerId/flow-revisions/:id'
  );
  gateways['sidekickThreads'] = new SidekickFlowsHttpGateway(backend);
  gateways['skillHierarchy'] = new StandardGateway(backend, 'v1/orgs/:orgId/skill-hierarchy/:skillHierarchyId');
  gateways['skills'] = new SkillGateway(backend);
  gateways['taskRouting'] = new StandardGateway(backend, 'v1/orgs/:orgId/configuration/task-routing');
  gateways['teams'] = new TeamsHttpGateway(backend);
  gateways['temporaryAuthTokens'] = new TemporaryAuthTokensGateway(backend);
  gateways['threads'] = new ThreadsGateway(backend);
  gateways['token'] = new StandardGateway(backend, 'v3/orgs/:orgId/users/:userId/desktop_tokens');
  gateways['users'] = new UserHttpGateway(backend);

  return gateways;
};

export { configureGateways };
